import {combineReducers, configureStore} from "@reduxjs/toolkit";
import passMatchedReducer from "./passMatchedReducer";
import partnerInvoicesReducer from "./partnerInvoicesReducer";
import partnerProfileInfoUpdateStateReducer from "./partnerProfileInfoUpadateStateReducer";
import signingUpStateReducer from "./signingUpStateReducer";
import referralLinkReducer from "./referralLinkReducer";
import analyticsTimeFrameReducer from "./analyticsTimeFrameReducer";
import analyticsTypeReducer from "./analyticsTypeReducer";
import companyIdListReducer from "./companyIdListReducer";
import magicLinkReducer from "./magicLinkReducer";
import clientSecretReducer from "./clientSecretReducer";
import achBankInfoReducer from "./achBankInfoReducer";
import weeklyNotificationEmailsReducerMapping from "./weeklyNotificationEmailsReducer";
import extendedReportReducerMapping from "./extendedReportReducer";
import companyConfigurationsReducerMapping from "./companyConfigurtionsReducer";
import leftSideBarReducerMapping from "./leftSideBarReducer";
import selectedComponentReducerMapping from "./selectedComponentReducer";
import companyReviewSummaryReducerMapping from "./companyReviewSummaryReducer";
import companyAiInsightsReducerMapping from "./companyAiInsightsReducer";
import allCompanyReviewSummaryReducerMapping from "./allCompanyReviewSummaryReducer";
import reviewAiInsightsReducerMapping from "./reviewAiInsightsReducer";
import operationalAiInsightsRecuderMapping from "./operationalAiInsightsReducer";
import reviewsListReducerMapping from "./reviewsListReducer";
import enterpriseDetailsReducerMapping from "./enterpriseDetailsReducer";
import enterpriseLevelsDetailsReducerMapping from "./enterpriseLevelsDetailsReducer";
import plansReducerMapping from "./plansReducer";
import companiesIdTokenReducerMapping from "./companiesIdTokenReducer";
import reviewChatRoomsReducerMapping from "./reviewChatRoomsReducer";
import reviewInitiateReducerMapping from "./reviewInitiateReducer";
import aiResponseReducer from "./aiResponseReducer";
import reviewNotificationEmailsReducerMapping from "./reviewNotificationEmailsReducer";
import usersReducerMapping from './usersReducer';
import usersUpdateReducerMapping from './usersUpdateReducer';
import passwordUpdateReducerMapping from './passwordUpdateReducer';
import activeCompanyReducerMapping from "./activeCompanyReducer";
import ownRoleReducerMapping from "./ownRoleReducer";
import performanceTimeFrameReducerMapping from "./performanceTimeFrameReducer";
import { enterpriseApiSlice } from "../Apis";

const rootReducer = combineReducers({
    passMatched: passMatchedReducer,
    partnerInvoices: partnerInvoicesReducer,
    partnerProfileInfoUpdateState: partnerProfileInfoUpdateStateReducer,
    signingUpState: signingUpStateReducer,
    referralLink: referralLinkReducer,
    analyticsTimeFrame: analyticsTimeFrameReducer,
    analyticsType: analyticsTypeReducer,
    companyIdList: companyIdListReducer,
    magicLink: magicLinkReducer,
    clientSecret: clientSecretReducer,
    achBankInfo: achBankInfoReducer,
    ...weeklyNotificationEmailsReducerMapping,
    ...extendedReportReducerMapping,
    ...companyConfigurationsReducerMapping,
    ...leftSideBarReducerMapping,
    ...selectedComponentReducerMapping,
    ...companyReviewSummaryReducerMapping,
    ...companyAiInsightsReducerMapping,
    ...allCompanyReviewSummaryReducerMapping,
    ...reviewAiInsightsReducerMapping,
    ...operationalAiInsightsRecuderMapping,
    ...reviewsListReducerMapping,
    ...enterpriseDetailsReducerMapping,
    ...enterpriseLevelsDetailsReducerMapping,
    ...plansReducerMapping,
    ...companiesIdTokenReducerMapping,
    ...reviewChatRoomsReducerMapping,
    ...reviewInitiateReducerMapping,
    ...aiResponseReducer,
    ...reviewNotificationEmailsReducerMapping,
    ...usersReducerMapping,
    ...usersUpdateReducerMapping,
    ...passwordUpdateReducerMapping,
    ...activeCompanyReducerMapping,
    ...ownRoleReducerMapping,
    ...performanceTimeFrameReducerMapping,
    [enterpriseApiSlice.reducerPath]: enterpriseApiSlice.reducer,
});

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(enterpriseApiSlice.middleware),
});

export default rootReducer;
